import { useState } from 'react'

export const DiscountState = () => {
    const [showMyDiscount, setShowMyDiscount] = useState(false)
    const [discountList, setDiscountList] = useState([])
    const [toExpire, setToExpire] = useState('')

    return {
        showMyDiscount: {data: showMyDiscount, set: setShowMyDiscount},
        discountList: {data: discountList, set: setDiscountList},
        toExpire: {data: toExpire, set: setToExpire},
    }
}
